import React, { useEffect } from 'react';
import mazeBackground from '../maze-background.png';

interface BackgroundProps {
  className?: string;
}

const Background: React.FC<BackgroundProps> = ({ className = '' }) => {
  useEffect(() => {
    // Apply the background to the body element with a more subtle white overlay
    document.body.style.background = `
      linear-gradient(rgba(255,255,255,0.95), rgba(255,255,255,0.95)),
      url(${mazeBackground}) no-repeat center center fixed
    `;
    document.body.style.backgroundSize = 'cover';
    document.body.style.backgroundAttachment = 'fixed';
    document.body.style.minHeight = '100vh';
    
    return () => {
      // Clean up when component unmounts
      document.body.style.background = '';
      document.body.style.backgroundSize = '';
      document.body.style.backgroundAttachment = '';
      document.body.style.minHeight = '';
    };
  }, []);

  return (
    <div className={`background-overlay ${className}`}>
      {/* The maze background is applied to body, this overlay can add additional effects */}
    </div>
  );
};

export default Background; 